import { cn } from "@/lib/utils.ts";

/**
 * The pill's look, without its position. Shared with the user's own reaction
 * when it doubles as the button that changes it, so the two read as one thing.
 */
export const reactionPillClassName =
  "flex gap-1 rounded-full border bg-popover px-2.5 py-1.5 text-base leading-none shadow select-none";

/**
 * An emoji reaction drawn as a small pill. Always visible: it is part of the
 * message, not a hover affordance like the footer.
 *
 * okthx's reaction on a user message overlaps the bubble's bottom-right corner.
 * The user's reaction on one of okthx's replies (`reactor="you"`) is the same
 * pill, but a reply has no bubble to sit on, so the caller places it with
 * `className`.
 */
export const ReactionBadge = ({
  reactions,
  reactor = "okthx",
  className,
}: {
  reactions: readonly string[];
  reactor?: "okthx" | "you";
  className?: string;
}) => {
  if (reactions.length === 0) return null;
  return (
    <div
      role="img"
      aria-label={`${reactor === "you" ? "You" : "okthx"} reacted ${reactions.join(" ")}`}
      className={cn("absolute -bottom-4 right-3", reactionPillClassName, className)}
    >
      {reactions.map((emoji, index) => (
        // Position is the only stable key: the same emoji can appear twice.
        // biome-ignore lint/suspicious/noArrayIndexKey: static list, never reordered
        <span key={index}>{emoji}</span>
      ))}
    </div>
  );
};
